export default __webpack_public_path__ + "static/media/searchMusicMp3.95bd70b5.svg";